import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	pageData: {
		id: "",
		name: "",
		startDate: "",
		shortStartDate: "",
		endDate: "",
		shortEndDate: "",
		duration: "",
		durationSpan: "",
		grade: null,
		certificateNumber: null,
		base64QrCode: "",
		trainingType: "",
		ratingEval: null,
		commentEval: null,
		enrollmentStatus: {
			id: "",
			siteId: "",
			nome: "",
			externalId: null,
		},
		modality: {
			id: "",
			Code: "",
			name: "",
		},
	},
};

const CourseCompletedDetailsSlice = createSlice({
	name: "CourseCompletedDetails",
	initialState: initialState,
	reducers: {
		updatePageData(state, action) {
			// console.log("update CourseCompletedDetails");
			// console.log(action);

			state.pageData = action.payload;
		},
	},
});

export const CourseCompletedDetailsActions =
	CourseCompletedDetailsSlice.actions;

export default CourseCompletedDetailsSlice;
